export const CONSULT_COMBOS_IDS = [
  'tipo_mercado',
  'provincias',
  'uso_punto_suministro',
  'productos_instalacion',
]
